const translations = {
  en: {
    // Navigation
    dashboard: "Dashboard",
    orders: "Orders",
    category: "Category",
    sellers: "Sellers",
    paymentRequest: "Payment Request",
    deactiveSellers: "Deactive Sellers",
    sellersRequest: "Sellers Request",
    chatSeller: "Chat Seller",
    chatSellerTitle: "Sellers",
    addProduct: "Add Product",
    allProduct: "All Product",
    discountProduct: "Discount Product",
    payments: "Payments",
    chatCustomer: "Chat Customer",
    chatSupport: "Chat Support",
    profile: "Profile",
    logout: "Logout",
    addAdmin: "Add Admin",

    // Common
    search: "Search",
    admin: "Admin",
    seller: "Seller",
    save: "Save",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    view: "View",
    submit: "Submit",
    update: "Update",
    add: "Add",
    actions: "Actions",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",

    // Products
    productName: "Product Name",
    productCategory: "Product Category",
    productBrand: "Product Brand",
    productStock: "Product Stock",
    productPrice: "Product Price",
    productDiscount: "Product Discount",
    productDescription: "Product Description",
    productImages: "Product Images",
    selectCategory: "Select Category",
    selectBrand: "Select Brand",
    editProduct: "Edit Product",
    inStock: "In Stock",
    outOfStock: "Out of Stock",

    // Orders
    orderId: "Order ID",
    customerName: "Customer Name",
    orderDate: "Order Date",
    orderStatus: "Order Status",
    orderDetails: "Order Details",
    statusLabel: "Status",
    updatedBySeller: "(Updated by Seller)",
    paymentStatus: "Payment Status",
    orderAmount: "Order Amount",
    deliveryStatus: "Delivery Status",
    placed: "Placed",
    processing: "Processing",
    shipped: "Shipped",
    delivered: "Delivered",
    warehouse: "Warehouse",
    cancelled: "Cancelled",
    paid: "Paid",
    unpaid: "Unpaid",
    deliverTo: "Deliver to",
    address: "Address",
    division: "Region",
    city: "City",
    zone: "Zone",
    phoneNumber: "Phone-number",
    paymentStatusLabel: "Payment Status",
    priceLabel: "Price",
    brandLabel: "Brand",
    quantityLabel: "Quantity",
    sellerOrderLabel: "Seller {index}th order :",

    // Sellers
    sellerName: "Seller Name",
    sellerEmail: "Seller Email",
    sellerPhone: "Seller Phone",
    sellerShop: "Seller Shop",
    sellerStatus: "Seller Status",
    sellerPayment: "Seller Payment",
    shopName: "hagere shop",
    hagereShop: "Hagere Shop",
    shopInfo: "Shop Information",
    division: "Division",
    district: "District",

    // Category
    categoryName: "Category Name",
    categoryImage: "Category Image",
    addCategory: "Add Category",
    categories: "Categories",
    updateCategory: "Update Category",
    // Banners
    banners: "Banners",
    addBanner: "Add Banner",
    updateBanner: "Update Banner",
    selectBannerImage: "Select banner image",

    // Payment
    amount: "Amount",
    withdrawalAmount: "Withdrawal Amount",
    withdrawalRequestTitle: "Withdrawal request",
    pendingAmount: "Pending Amount",
    availableAmount: "Available Amount",
    requestDate: "Request Date",
    confirm: "Confirm",

    // Dashboard Stats
    totalSales: "Total Sales",
    totalProducts: "Total Products",
    products: "Products",
    // Seller products page
    productManagement: "Product Management",
    manageInventory: "Manage your product inventory",
    addNewProduct: "Add New Product",
    // Discount products page
    discountProducts: "Discount Products",
    discountProductsSubtitle: "View and manage products currently on discount",
    addDiscountProduct: "Add Discount Product",
    totalDiscountProducts: "Total Discounted Products",
    totalOrders: "Total Orders",
    totalSellers: "Total Sellers",
    totalEarnings: "Total Earnings",
    pendingOrders: "Pending Orders",
    recentOrders: "Recent Orders",
    adminCommission: "Admin Commission",
    sellerEarnings: "Seller Earnings",
    totalSellerEarnings: "Total Seller Earnings",
    paidToSellers: "Paid to Sellers",
    sellerRemainingBalance: "Seller Remaining Balance",
    recentCustomerMessage: "Recent customer message",
    recentSellerMessage: "Recent seller message",
    viewAll: "View All",
    revenue: "Revenue",
    sales: "Sales",
    // Dashboard specific
    dashboardOverview: "Dashboard Overview",
    dashboardOverviewSubtitle:
      "Welcome back, {name}! Here's what's happening with your platform today.",
    monthlyPerformanceOverview: "Monthly performance overview",
    ordersManagement: "Order Management",
    ordersManagementSubtitle: "View and manage all orders on the platform",
    analytics: "Analytics",
    // Seller dashboard
    sellerDashboard: "Seller Dashboard",
    sellerDashboardSubtitle:
      "Welcome back, {name}! Here's your store performance today.",
    sellerChartSubtitle: "Track your store performance over time",
    // Filters / table
    filtersLabel: "Filters:",
    allStatus: "All Status",
    allPayments: "All Payments",
    refresh: "Refresh",
    perPage: "{count} per page",
    items: "items",

    // Months
    jan: "Jan",
    feb: "Feb",
    mar: "Mar",
    apr: "Apr",
    may: "May",
    jun: "Jun",
    jul: "Jul",
    aug: "Aug",
    sep: "Sep",
    oct: "Oct",
    nov: "Nov",
    dec: "Dec",

    // Messages
    successMessage: "Operation successful",
    errorMessage: "Operation failed",
    backToDashboard: "Back to Dashboard",
    activationFailed: "Account activation failed",
    activationSuccess: "Account activated successfully",
    deleteConfirm: "Are you sure you want to delete?",
    updateSuccess: "Updated successfully",
    addSuccess: "Added successfully",
    deleteSuccess: "Deleted successfully",

    // Auth
    email: "Email",
    password: "Password",
    emailAddress: "Email Address",
    enterYourPassword: "Enter your password",
    adminLoginTitle: "Admin Login",
    login: "Login",
    register: "Register",
    forgotPassword: "Forgot Password?",
    resetPassword: "Reset Password",
    // Admin Reset
    adminResetTitle: "Admin Reset Password",
    enterNewPassword: "Enter new password",
    resetting: "Resetting...",
    passwordResetSuccess: "Password reset successful",
    passwordResetFailed: "Failed to reset password",

    // Profile
    shopImage: "Shop Image",
    changePassword: "Change Password",
    oldPassword: "Old Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",

    // Other
    noData: "No data available",
    loading: "Loading...",
    selectImage: "Select image",
    imageNotUploaded: "Image not uploaded",
    notUploaded: "Not uploaded",
    unknown: "Unknown",
    closePreview: "Close preview",
    showingResults: "Showing results",
    searchResults: "Search results",
    image: "Image",
    name: "Name",
    price: "Price",
    currency: "Birr",
    brand: "Brand",
    stock: "Stock",
    discount: "Discount",
    avgDiscount: "Avg Discount",
    description: "Description",
    date: "Date",
    details: "Details",
    update: "Update",
    noDiscount: "No discount",
    basicInfo: "Basic Info",
    selectStatus: "--select status--",
    notProvided: "Not provided",
    // Payments / Withdrawals
    sendWithdrawalRequest: "Send withdrawal Request",
    pendingWithdrows: "Pending withdrawal request",
    successWithdrows: "Success Withdrawal",
    no: "No",
    // Profile / Seller
    removing: "Removing...",
    removeImage: "Remove Image",
    role: "Role",
    shopName: "hagere shop",
    city: "City",
    changing: "Changing...",
    businessLicense: "Business License",
    removeLicense: "Remove License",
    selectBusinessLicense: "Select Business License",
    bankInformation: "Bank Information for Withdrawals",
    accountName: "Account Name",
    accountHolderName: "Account holder name",
    accountNumber: "Account Number",
    bankName: "Bank Name",
    selectBank: "Select Bank",
    updateBankInfo: "Update Bank Info",
    notSet: "Not set",
    bankCode: "Bank Code",
    addBankInfoWarning:
      "Please add your bank information to receive withdrawals",
    // Chat / Seller to Admin
    inputMessage: "Type your message",
    inputYourMessage: "Input your message",
    selectSeller: "Select a seller to start chat",
    send: "Send",
    seller: "Seller",
    // Admin Auth / Forgot Password
    adminForgotPasswordTitle: "Admin Forgot Password",
    resetLinkSent: "Reset link sent to your email",
    resetLinkFailed: "Failed to send reset link",
    serverError: "Server error",
    enterYourEmail: "Enter your email",
    sending: "Sending...",
    sendResetLink: "Send Reset Link",
    // Login / Welcome
    welcomeBack: "Welcome Back to",
    signInToContinue: "Sign in to continue your journey",
    dontHaveAccount: "Don’t have an account?",
    signUp: "Sign up",
    backToLogin: "Back to Login",
    // Seller Forgot
    sellerForgotTitle: "Seller Forgot Password",
    pendingAccountMessage:
      "Please submit all needed  information. Admin will review and activate your account.",
    updateInformation: "Update Information",
    accountDeactivatedMessage:
      "Your account has been deactivated by admin. Please contact support.",
    contactSupport: "Contact",
    // Add Admin
    enterAdminName: "Enter admin name",
    enterAdminEmail: "Enter admin email",
    enterPassword: "Enter password",
    creating: "Creating...",
    createAdmin: "Create Admin",
  },
  am: {
    // Navigation
    dashboard: "ዳሽቦርድ",
    orders: "ትእዛዞች",
    category: "ምድብ",
    sellers: "ሻጮች",
    paymentRequest: "የክፍያ ጥያቄ",
    deactiveSellers: "ያልተነቃቁ ሻጮች",
    sellersRequest: "የሻጮች ጥያቄ",
    chatSeller: "ከሻጭ ጋር ውይይት",
    chatSellerTitle: "ሻጮች",
    addProduct: "ምርት ጨምር",
    allProduct: "ሁሉም ምርቶች",
    discountProduct: "ቅናሽ ያላቸው ምርቶች",
    payments: "ክፍያዎች",
    chatCustomer: "ከደንበኛ ጋር ውይይት",
    chatSupport: "ድጋፍ ውይይት",
    profile: "መገለጫ",
    logout: "ውጣ",
    addAdmin: "አስተዳዳሪ ጨምር",

    // Common
    search: "ፈልግ",
    admin: "አስተዳዳሪ",
    seller: "ሻጭ",
    save: "አስቀምጥ",
    cancel: "ሰርዝ",
    edit: "አርትዕ",
    delete: "ሰርዝ",
    view: "ይመልከቅ",
    submit: "አስገባ",
    update: "አዘምን",
    add: "ጨምር",
    actions: "እርምጃዎች",
    status: "ሁኔታ",
    active: "ንቁ",
    inactive: "ያልተነቃ",
    pending: "በሂደት ላይ",
    approved: "ፀድቋል",
    rejected: "ተቀባይነት አላገኘም",

    // Products
    productName: "የምርት ስም",
    productCategory: "የምርት ምድብ",
    productBrand: "የምርት ምርት",
    productStock: "የምርት እቃ",
    productPrice: "የምርት ዋጋ",
    productDiscount: "የምርት ቅናሽ",
    productDescription: "የምርት መግለጫ",
    productImages: "የምርት ምስሎች",
    selectCategory: "ምድብ ይምረጡ",
    selectBrand: "ምርት ምርት ይምረጡ",
    editProduct: "ምርትን አርትዕ",
    inStock: "በእቃ ላይ አለ",
    outOfStock: "ከእቃ ውጭ",

    // Orders
    orderId: "የትእዛዝ መለያ",
    customerName: "የደንበኛ ስም",
    orderDate: "የትእዛዝ ቀን",
    orderStatus: "የትእዛዝ ሁኔታ",
    orderDetails: "የትእዛዝ ዝርዝር",
    statusLabel: "ሁኔታ",
    updatedBySeller: "(በሻጭ ዘዴ ዘምኗል)",
    paymentStatus: "የክፍያ ሁኔታ",
    orderAmount: "የትእዛዝ መጠን",
    deliveryStatus: "የእቃ አቅርቦት ሁኔታ",
    placed: "ተደርጓል",
    processing: "በሂደት ላይ",
    shipped: "ተልኳል",
    delivered: "ተደርሷል",
    warehouse: "በመደብር ውስጥ",
    cancelled: "ተሰርዟል",
    paid: "ተከፍሏል",
    unpaid: "አልተከፈለም",
    deliverTo: "ወደ ማነቃቂያ",
    address: "አድራሻ",
    division: "ክልል",
    city: "ከተማ",
    zone: "ዞን",
    phoneNumber: "ስልክ ቁጥር",
    paymentStatusLabel: "የክፍያ ሁኔታ",
    priceLabel: "ዋጋ",
    brandLabel: "ምርት",
    quantityLabel: "ብዛት",
    sellerOrderLabel: "ሻጭ {index} ኛ ትእዛዝ :",

    // Sellers
    sellerName: "የሻጭ ስም",
    sellerEmail: "የሻጭ ኢሜል",
    sellerPhone: "የሻጭ ስልክ",
    sellerShop: "የሻጭ ሱቅ",
    sellerStatus: "የሻጭ ሁኔታ",
    sellerPayment: "የሻጭ ክፍያ",
    shopName: "ሀገሬ ገበያ",
    hagereShop: "ሀገር ሱቅ",
    shopInfo: "የሱቅ መረጃ",
    division: "ክፍል",
    district: "ወረዳ",

    // Category
    categoryName: "የምድብ ስም",
    categoryImage: "የምድብ ምስል",
    addCategory: "ምድብ ጨምር",
    categories: "ምድቦች",
    updateCategory: "ምድብ አዘምን",

    // Payment
    amount: "መጠን",
    withdrawalAmount: "የመውጣት መጠን",
    withdrawalRequestTitle: "የመውጫ ጥያቄ",
    pendingAmount: "በሂደት ላይ ያለ መጠን",
    availableAmount: "ያለ መጠን",
    requestDate: "የጥያቄ ቀን",
    confirm: "አረጋግጥ",

    // Dashboard Stats
    totalSales: "ጠቅላላ ሽያጭ",
    totalProducts: "ጠቅላላ ምርቶች",
    products: "ምርቶች",
    // Seller products page
    productManagement: "የምርት አስተዳደር",
    manageInventory: "የምርትዎን እቃ ይያዙ",
    addNewProduct: "አዲስ ምርት አስገባ",
    // Discount products page
    discountProducts: "ቅናሽ ያሉ ምርቶች",
    discountProductsSubtitle: "በቅናሽ ላይ ያሉ ምርቶችን ይመልከቱ እና ይያዙ",
    addDiscountProduct: "የቅናሽ ምርት ጨምር",
    totalDiscountProducts: "ጠቅላላ የቅናሽ ያሉ ምርቶች",
    totalOrders: "ጠቅላላ ትእዛዞች",
    totalSellers: "ጠቅላላ ሻጮች",
    totalEarnings: "ጠቅላላ ገቢ",
    pendingOrders: "በሂደት ላይ ያሉ ትእዛዞች",
    recentOrders: "የቅርብ ጊዜ ትእዛዞች",
    adminCommission: "የአስተዳዳሪ ኮሚሽን",
    sellerEarnings: "የሻጭ ገቢ",
    totalSellerEarnings: "ጠቅላላ የሻጭ ገቢ",
    paidToSellers: "ለሻጮች የተከፈለ",
    sellerRemainingBalance: "የሻጭ ቀሪ ሂሳብ",
    recentCustomerMessage: "የቅርብ ጊዜ የደንበኛ መልዕክት",
    recentSellerMessage: "የቅርብ ጊዜ የሻጭ መልዕክት",
    viewAll: "ሁሉንም ይመልከቱ",
    revenue: "ገቢ",
    sales: "ሽያጭ",

    // Months
    jan: "ጃንዩ",
    feb: "ፌብሩ",
    mar: "ማርች",
    apr: "ኤፕሪል",
    may: "ሜይ",
    jun: "ጁን",
    jul: "ጁላይ",
    aug: "ኦገስት",
    sep: "ሴፕቴም",
    oct: "ኦክቶ",
    nov: "ኖቬም",
    dec: "ዲሴም",

    // Messages
    successMessage: "ተግባር በተሳካ ሁኔታ ተከናውኗል",
    errorMessage: "ተግባር አልተሳካም",
    backToDashboard: "ወደ ዳሽቦርድ ተመለስ",
    activationFailed: "የሂሳብ ንቃት አልተሳካም",
    activationSuccess: "ሂሳብ በተሳካ ሁኔታ ነበር",
    deleteConfirm: "ለመሰረዝ እርግጠኛ ነዎት?",
    unauthorizedMessage: "You can't access this page",
    updateSuccess: "በተሳካ ሁኔታ ተዘምኗል",
    addSuccess: "በተሳካ ሁኔታ ታክሏል",
    deleteSuccess: "በተሳካ ሁኔታ ተሰርዟል",

    // Auth
    // Admin Auth / Forgot Password
    adminForgotPasswordTitle: "የአስተዳዳሪ የይለፍ ቃል ረሳ",
    resetLinkSent: "የዳግም አገናኝ ወደ ኢሜልዎ ተልኳል",
    resetLinkFailed: "የዳግም አገናኝ ማስተላለፊያ አልተሳካም",
    serverError: "የአገልግሎት ስህተት",
    enterYourEmail: "የኢሜልዎን አድራሻ ያስገቡ",
    sending: "በላክ ላይ...",
    sendResetLink: "የዳግም አገናኝ ላክ",
    backToLogin: "ወደ ግባ ተመለስ",
    // Seller Forgot
    sellerForgotTitle: "የሻጭ የይለፍ ቃል ረሳ",
    pendingAccountMessage:
      "እባክዎ የቀሩትን መረጃዎች ያስገቡና። አስተዳዳሪው እንዲገምግም እና እንዲንቃው ይጠብቃል።",
    updateInformation: "መረጃ አዘምን",
    accountDeactivatedMessage: "ሂሳብዎን አስተዳዳሪው አዘጋጅቷል። እባክዎ ወደ ድጋፍ ይገናኙ።",
    contactSupport: "ያግኙ",
    // Register
    joinShop: "የግብዣ ሱቅ ይቀላቀሉ",
    createAccountStartBusiness: "ንግድዎን ለመጀመር መለያ ይፍጠሩ",
    name: "ስም",
    yourName: "ስምዎ",
    createPassword: "የይለፍ ቃል ይፍጠሩ",
    iAgreeToThe: "እስማማለሁ",
    privacyPolicy: "የግላዊነት ፖሊሲ",
    terms: "ደንቦች",
    alreadyHaveAccount: "አለዎት መለያ?",
    signIn: "ግባ",
    verifyYourEmail: "ኢሜልዎን ያረጋግጡ",
    enterThe6DigitCodeSentTo: "ወደ ላከው 6-ቁጥር ኮድ ያስገቡ",
    verifyEmail: "ኢሜል ያረጋግጡ",
    didntGetTheCode: "ኮድ አልገኘም?",
    resend: "እንደገና ላክ",
    // Login / Welcome
    welcomeBack: "ወደ ዳግም እንኳን ደህና መጡ",
    signInToContinue: "ጉዞዎን ለመቀጠል ይግቡ",
    dontHaveAccount: "መለያ አለዎት?",
    signUp: "ይመዝገቡ",

    email: "ኢሜል",
    password: "የይለፍ ቃል",
    login: "ግባ",
    register: "ይመዝገቡ",
    forgotPassword: "የሚያስታውሰው ረሳዋት?",
    resetPassword: "የይለፍ ቃል ዳግም ቀይር",
    // Admin Reset
    adminResetTitle: "የአስተዳዳሪ የይለፍ ቃል እንደገና ቀይር",
    enterNewPassword: "አዲስ የይለፍ ቃል ያስገቡ",
    resetting: "በማድረግ ላይ...",
    passwordResetSuccess: "የይለፍ ቃል በተሳካ ሁኔታ ታክሏል",
    passwordResetFailed: "የይለፍ ቃል መቀየር አልተሳካም",

    // Profile
    shopImage: "የሱቅ ምስል",
    changePassword: "የይለፍ ቃል ቀይር",
    oldPassword: "የድሮ የይለፍ ቃል",
    newPassword: "አዲስ የይለፍ ቃል",
    confirmPassword: "የይለፍ ቃል አረጋግጥ",

    // Other
    noData: "ምንም መረጃ የለም",
    loading: "በመጫን ላይ...",
    selectImage: "ምስል ይምረጡ",
    imageNotUploaded: "ምስል አልተስጓም",
    notUploaded: "አልተስጠም",
    closePreview: "ዝጋ",
    showingResults: "ውጤቶችን በማሳየት",
    searchResults: "የፍለጋ ውጤቶች",
    image: "ምስል",
    name: "ስም",
    price: "ዋጋ",
    currency: "ብር",
    brand: "ምርት ምርት",
    stock: "እቃ",
    discount: "ቅናሽ",
    avgDiscount: "አማካይ ቅናሽ",
    description: "መግለጫ",
    date: "ቀን",
    details: "ዝርዝሮች",
    // },
    // am: {
    // Navigation
    dashboard: "ዳሽቦርድ",
    orders: "ትእዛዞች",
    category: "ምድብ",
    sellers: "ሻጮች",
    paymentRequest: "የክፍያ ጥያቄ",
    deactiveSellers: "ያልተነቃቁ ሻጮች",
    sellersRequest: "የሻጮች ጥያቄ",
    chatSeller: "ከሻጭ ጋር ውይይት",
    chatSellerTitle: "ሻጮች",
    addProduct: "ምርት ጨምር",
    allProduct: "ሁሉም ምርቶች",
    discountProduct: "ቅናሽ ያላቸው ምርቶች",
    payments: "ክፍያዎች",
    chatCustomer: "ከደንበኛ ጋር ውይይት",
    chatSupport: "ድጋፍ ውይይት",
    profile: "መገለጫ",
    logout: "ውጣ",
    addAdmin: "አስተዳዳሪ ጨምር",

    // Common
    search: "ፈልግ",
    admin: "አስተዳዳሪ",
    seller: "ሻጭ",
    save: "አስቀምጥ",
    cancel: "ሰርዝ",
    edit: "አርትዕ",
    delete: "ሰርዝ",
    view: "ይመልከቅ",
    submit: "አስገባ",
    update: "አዘምን",
    add: "ጨምር",
    actions: "እርምጃዎች",
    status: "ሁኔታ",
    active: "ንቁ",
    inactive: "ያልተነቃ",
    pending: "በሂደት ላይ",
    approved: "ፀድቋል",
    rejected: "ተቀባይነት አላገኘም",

    // Products
    productName: "የምርት ስም",
    productCategory: "የምርት ምድብ",
    productBrand: "የምርት ምርት",
    productStock: "የምርት እቃ",
    productPrice: "የምርት ዋጋ",
    productDiscount: "የምርት ቅናሽ",
    productDescription: "የምርት መግለጫ",
    productImages: "የምርት ምስሎች",
    selectCategory: "ምድብ ይምረጡ",
    selectBrand: "ምርት ምርት ይምረጡ",
    inStock: "በእቃ ላይ አለ",
    outOfStock: "ከእቃ ውጭ",

    // Orders
    orderId: "የትእዛዝ መለያ",
    customerName: "የደንበኛ ስም",
    orderDate: "የትእዛዝ ቀን",
    orderStatus: "የትእዛዝ ሁኔታ",
    orderDetails: "የትእዛዝ ዝርዝር",
    statusLabel: "ሁኔታ",
    updatedBySeller: "(በሻጭ ዘዴ ዘምኗል)",
    paymentStatus: "የክፍያ ሁኔታ",
    orderAmount: "የትእዛዝ መጠን",
    deliveryStatus: "የእቃ አቅርቦት ሁኔታ",
    placed: "ተደርጓል",
    processing: "በሂደት ላይ",
    shipped: "ተልኳል",
    delivered: "ተደርሷል",
    warehouse: "በመደብር ውስጥ",
    cancelled: "ተሰርዟል",
    paid: "ተከፍሏል",
    unpaid: "አልተከፈለም",
    deliverTo: "ወደ ማነቃቂያ",
    address: "አድራሻ",
    division: "ክልል",
    city: "ከተማ",
    zone: "ዞን",
    phoneNumber: "ስልክ ቁጥር",
    paymentStatusLabel: "የክፍያ ሁኔታ",
    priceLabel: "ዋጋ",
    brandLabel: "ምርት",
    quantityLabel: "ብዛት",
    sellerOrderLabel: "ሻጭ {index} ኛ ትእዛዝ :",

    // Sellers
    sellerName: "የሻጭ ስም",
    sellerEmail: "የሻጭ ኢሜል",
    sellerPhone: "የሻጭ ስልክ",
    sellerShop: "የሻጭ ሱቅ",
    sellerStatus: "የሻጭ ሁኔታ",
    sellerPayment: "የሻጭ ክፍያ",
    shopName: "ሀገሬ ገበያ",
    shopInfo: "የሱቅ መረጃ",
    division: "ክፍል",
    district: "ወረዳ",

    // Category
    categoryName: "የምድብ ስም",
    categoryImage: "የምድብ ምስል",
    addCategory: "ምድብ ጨምር",
    // Banners
    banners: "ባነሮች",
    addBanner: "ባነር ጨምር",
    updateBanner: "ባነር አዘምን",
    selectBannerImage: "የባነር ምስል ይምረጡ",

    // Payment
    amount: "መጠን",
    withdrawalAmount: "የመውጣት መጠን",
    withdrawalRequestTitle: "የመውጫ ጥያቄ",
    pendingAmount: "በሂደት ላይ ያለ መጠን",
    availableAmount: "ያለ መጠን",
    requestDate: "የጥያቄ ቀን",
    confirm: "አረጋግጥ",

    // Dashboard Stats
    totalSales: "ጠቅላላ ሽያጭ",
    totalProducts: "ጠቅላላ ምርቶች",
    totalOrders: "ጠቅላላ ትእዛዞች",
    totalSellers: "ጠቅላላ ሻጮች",
    totalEarnings: "ጠቅላላ ገቢ",
    pendingOrders: "በሂደት ላይ ያሉ ትእዛዞች",
    recentOrders: "የቅርብ ጊዜ ትእዛዞች",
    adminCommission: "የአስተዳዳሪ ኮሚሽን",
    sellerEarnings: "የሻጭ ገቢ",
    totalSellerEarnings: "ጠቅላላ የሻጭ ገቢ",
    paidToSellers: "ለሻጮች የተከፈለ",
    sellerRemainingBalance: "የሻጭ ቀሪ ሂሳብ",
    recentCustomerMessage: "የቅርብ ጊዜ የደንበኛ መልዕክት",
    recentSellerMessage: "የቅርብ ጊዜ የሻጭ መልዕክት",
    viewAll: "ሁሉንም ይመልከቱ",
    revenue: "ገቢ",
    sales: "ሽያጭ",
    // Dashboard specific
    dashboardOverview: "የዳሽቦርድ አጠቃላይ እይታ",
    dashboardOverviewSubtitle: "ደህና መጡ, {name}! ዛሬ በፕላትፎርምዎ የሚገኙ ነገሮች እዚህ ናቸው።",
    monthlyPerformanceOverview: "የወርሃዊ አፈፃፀም እይታ",
    ordersManagement: "የትእዛዝ አስተዳደር",
    ordersManagementSubtitle: "በመድረክ ላይ ያሉ ሁሉንም ትእዛዞች ይመልከቱ እና ያስተዳዱ",
    analytics: "ትንበያ",
    // Seller dashboard
    sellerDashboard: "የሻጭ ዳሽቦርድ",
    sellerDashboardSubtitle: "ወደ ሱቅዎ ደህና መጡ, {name}! ዛሬ የሱቅዎ አፈፃፀም እዚህ ነው።",
    sellerChartSubtitle: "የሱቅዎን አፈፃፀም በጊዜ ላይ ይከታተሉ",
    // Filters / table
    filtersLabel: "ፍለጋ አማራጮች:",
    allStatus: "ሁሉም ሁኔታ",
    allPayments: "ሁሉም ክፍያዎች",
    refresh: "አዘምን",
    perPage: "{count} በገፅ",
    items: "እቃዎች",

    // Months
    jan: "ጃንዩ",
    feb: "ፌብሩ",
    mar: "ማርች",
    apr: "ኤፕሪል",
    may: "ሜይ",
    jun: "ጁን",
    jul: "ጁላይ",
    aug: "ኦገስት",
    sep: "ሴፕቴም",
    oct: "ኦክቶ",
    nov: "ኖቬም",
    dec: "ዲሴም",

    // Messages
    successMessage: "ተግባር በተሳካ ሁኔታ ተከናውኗል",
    errorMessage: "ተግባር አልተሳካም",
    deleteConfirm: "ለመሰረዝ እርግጠኛ ነዎት?",
    updateSuccess: "በተሳካ ሁኔታ ተዘምኗል",
    addSuccess: "በተሳካ ሁኔታ ታክሏል",
    deleteSuccess: "በተሳካ ሁኔታ ተሰርዟል",

    // Auth
    email: "ኢሜል",
    password: "የይለፍ ቃል",
    emailAddress: "የኢሜል አድራሻ",
    enterYourPassword: "የይለፍ ቃልዎን አስገባ",
    adminLoginTitle: "የአስተዳዳሪ ግባ",
    login: "ግባ",
    register: "ይመዝገቡ",
    forgotPassword: "የሚያስታውሰው ረሳዋት?",
    resetPassword: "የይለፍ ቃል ዳግም ቀይር",
    // Admin Reset
    adminResetTitle: "የአስተዳዳሪ የይለፍ ቃል እንደገና ቀይር",
    enterNewPassword: "አዲስ የይለፍ ቃል ያስገቡ",
    resetting: "በማድረግ ላይ...",
    passwordResetSuccess: "የይለፍ ቃል በተሳካ ሁኔታ ታክሏል",
    passwordResetFailed: "የይለፍ ቃል መቀየር አልተሳካም",
    // Admin Auth / Forgot Password
    adminForgotPasswordTitle: "የአስተዳዳሪ የይለፍ ቃል ረሳ",
    resetLinkSent: "የዳግም አገናኝ ወደ ኢሜልዎ ተልኳል",
    resetLinkFailed: "የዳግም አገናኝ ማስተላለፊያ አልተሳካም",
    serverError: "የአገልግሎት ስህተት",
    enterYourEmail: "የኢሜልዎን አድራሻ ያስገቡ",
    sending: "በላክ ላይ...",
    sendResetLink: "የዳግም አገናኝ ላክ",
    backToLogin: "ወደ ግባ ተመለስ",
    // Seller Forgot
    sellerForgotTitle: "የሻጭ የይለፍ ቃል ረሳ",
    pendingAccountMessage:
      "እባክዎ የቀሩትን መረጃዎች ያስገቡና ። አስተዳዳሪው እንዲገምግም እና እንዲንቃው ይጠብቃል።",
    updateInformation: "መረጃ አዘምን",
    accountDeactivatedMessage: "ሂሳብዎን አስተዳዳሪው አዘጋጅቷል። እባክዎ ወደ ድጋፍ ይገናኙ።",
    contactSupport: "ያግኙ",
    // Register
    joinShop: "የግብዣ ሱቅ ይቀላቀሉ",
    createAccountStartBusiness: "ንግድዎን ለመጀመር መለያ ይፍጠሩ",
    yourName: "ስምዎ",
    createPassword: "የይለፍ ቃል ይፍጠሩ",
    iAgreeToThe: "እስማማለሁ",
    privacyPolicy: "የግላዊነት ፖሊሲ",
    terms: "ደንቦች",
    alreadyHaveAccount: "አለዎት መለያ?",
    signIn: "ግባ",
    verifyYourEmail: "ኢሜልዎን ያረጋግጡ",
    enterThe6DigitCodeSentTo: "ወደ ላከው 6-ቁጥር ኮድ ያስገቡ",
    verifyEmail: "ኢሜል ያረጋግጡ",
    didntGetTheCode: "ኮድ አልገኘም?",
    resend: "እንደገና ላክ",
    // Login / Welcome
    welcomeBack: "ወደ ዳግም እንኳን ደህና መጡ",
    hagereShop: "ሀገር ሱቅ",
    signInToContinue: "ጉዞዎን ለመቀጠል ይግቡ",
    dontHaveAccount: "መለያ አለዎት?",
    signUp: "ይመዝገቡ",
    backToDashboard: "ወደ ዳሽቦርድ ተመለስ",
    activationFailed: "የሂሳብ ንቃት አልተሳካም",
    activationSuccess: "ሂሳብ በተሳካ ሁኔታ ነበር",
    unauthorizedMessage: "ወደዚህ ገጽ መድረስ አይችሉም",

    // Profile
    shopImage: "የሱቅ ምስል",
    changePassword: "የይለፍ ቃል ቀይር",
    oldPassword: "የድሮ የይለፍ ቃል",
    newPassword: "አዲስ የይለፍ ቃል",
    confirmPassword: "የይለፍ ቃል አረጋግጥ",

    // Other
    noData: "ምንም መረጃ የለም",
    loading: "በመጫን ላይ...",
    selectImage: "ምስል ይምረጡ",
    unknown: "ያልታወቀ",
    showingResults: "ውጤቶችን በማሳየት",
    searchResults: "የፍለጋ ውጤቶች",
    image: "ምስል",
    name: "ስም",
    price: "ዋጋ",
    currency: "ብር",
    brand: "ምርት ምርት",
    stock: "እቃ",
    discount: "ቅናሽ",
    description: "መግለጫ",
    date: "ቀን",
    details: "ዝርዝሮች",
    noDiscount: "ምንም ቅናሽ የለም",
    basicInfo: "መሠረታዊ መረጃ",
    selectStatus: "--ሁኔታ ይምረጡ--",
    notProvided: "አልተሰጠም",
    // Payments / Withdrawals
    sendWithdrawalRequest: "የመውጣት ጥያቄ ላክ",
    pendingWithdrows: "በሂደት ያለ የመውጣት ጥያቄ",
    successWithdrows: "የስኬታማ መውጣቶች",
    no: "ቁጥር",
    // Profile / Seller
    removing: "በማስወገድ ላይ...",
    removeImage: "ምስል አስወግድ",
    role: "ሚና",
    city: "ከተማ",
    changing: "በመቀየር ላይ...",
    businessLicense: "የንግድ ፈቃድ",
    removeLicense: "ፈቃድ አስወግድ",
    selectBusinessLicense: "የንግድ ፈቃድ ይምረጡ",
    bankInformation: "ለውጣቶች የባንክ መረጃ",
    accountName: "የሂሳብ ስም",
    accountHolderName: "የሂሳብ ባለቤት ስም",
    accountNumber: "የሂሳብ ቁጥር",
    bankName: "የባንክ ስም",
    selectBank: "ባንክ ይምረጡ",
    updateBankInfo: "የባንክ መረጃ አዘምን",
    notSet: "አልተዘጋጀም",
    bankCode: "የባንክ ኮድ",
    addBankInfoWarning: "እባክዎ ለውጣቶች የባንክ መረጃዎን ያክሉ",
    // Chat / Seller to Admin
    inputMessage: "መልእክትዎን ይተይቡ",
    inputYourMessage: "መልእክትዎን ያስገቡ",
    selectSeller: "ውይይት ለመጀመር ሻጭ ይምረጡ",
    send: "ላክ",
    // Add Admin
    enterAdminName: "የአስተዳዳሪ ስም ያስገቡ",
    enterAdminEmail: "የአስተዳዳሪ ኢሜል ያስገቡ",
    enterPassword: "የይለፍ ቃል ያስገቡ",
    creating: "በመፍጠር ላይ...",
    createAdmin: "አስተዳዳሪ ፍጠር",
  },
};

export default translations;
